import React from "react";
import PropTypes from "prop-types";

const overlayStyle = (isMobile) => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(5, 13, 23, 0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1050,
  padding: isMobile ? "12px" : "20px",
});

const modalStyle = (isMobile) => ({
  width: isMobile ? "90%" : "100%",
  maxWidth: "520px",
  background: "#ffffff",
  borderRadius: isMobile ? "24px" : "16px",
  boxShadow: isMobile ? "0 -10px 40px rgba(0,0,0,0.25)" : "0 25px 60px rgba(0,0,0,0.25)",
  overflow: "hidden",
  maxHeight: isMobile ? "88vh" : "auto",
  overflowY: isMobile ? "auto" : "visible",
  position: "relative",
});

const headerStyle = {
  padding: "20px 48px 10px 24px",
  borderBottom: "1px solid #f0f0f0",
};

const bodyStyle = {
  padding: "16px 24px 24px",
  color: "#1f2933",
  lineHeight: 1.5,
  fontSize: "15px",
};

const listStyle = {
  paddingLeft: "20px",
  margin: "10px 0 20px",
};

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  background: "#ecffef",
  color: "#15803d",
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 600,
};

const footerStyle = {
  padding: "16px 24px 24px",
  borderTop: "1px solid #f0f0f0",
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
};

const primaryButtonStyle = {
  border: "none",
  borderRadius: "999px",
  background: "#16a34a",
  color: "#fff",
  padding: "10px 22px",
  fontWeight: 600,
  cursor: "pointer",
};

const closeButtonStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  background: "transparent",
  border: "none",
  fontSize: "22px",
  cursor: "pointer",
  color: "#64748b",
};

const GuaranteeHelpModal = ({
  isOpen = false,
  onClose = () => {},
  titleRenderer = null,
  bodyRenderer = null,
  footerRenderer = null,
}) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const mediaQuery = window.matchMedia("(max-width: 991px)");
    const update = () => setIsMobile(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle(isMobile)} onClick={onClose}>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={modalStyle(isMobile)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button aria-label="Fermer" style={closeButtonStyle} onClick={onClose}>
            ×
          </button>
          <div style={headerStyle}>
            {titleRenderer ? (
              titleRenderer()
            ) : (
              <>
                <div style={badgeStyle}>Aide sur les garanties</div>
                <h2 style={{ margin: "12px 0 0", fontSize: "20px" }}>
                  Comment vérifier si vous êtes couvert ?
                </h2>
              </>
            )}
          </div>
          <div style={bodyStyle}>
            {bodyRenderer ? (
              bodyRenderer()
            ) : (
              <>
                <p>
                  Plusieurs types de protections existent pour votre appareil. Voici les plus
                  fréquentes :
                </p>
                <ul style={listStyle}>
                  <li>
                    <strong>Garantie constructeur :</strong> valable 2 ans en moyenne à compter de la
                    date d’achat.
                  </li>
                  <li>
                    <strong>Extension de garantie :</strong> souscrite en magasin ou auprès d’un
                    assureur pour prolonger la couverture initiale.
                  </li>
                  <li>
                    <strong>Contrat de protection / assurance habitation :</strong> certains contrats
                    couvrent aussi vos appareils électroménagers.
                  </li>
                </ul>
                <p style={{ marginBottom: 12 }}>Pour savoir si vous êtes couvert :</p>
                <ol style={{ paddingLeft: 20, margin: "0 0 16px" }}>
                  <li>
                    Retrouvez votre facture ou ticket d’achat (email, espace client, application
                    bancaire).
                  </li>
                  <li>
                    Vérifiez vos emails de confirmation ou votre compte distributeur (Fnac, Darty,
                    Boulanger, etc.).
                  </li>
                  <li>
                    Consultez votre banque ou votre assurance : certaines cartes premium incluent des
                    protections.
                  </li>
                  <li>
                    Demandez au vendeur initial : ils peuvent retrouver la date d’achat via le numéro
                    de série.
                  </li>
                </ol>
                <p style={{ marginBottom: 0 }}>
                  Si vous avez un doute, sélectionnez l’option correspondante et Marc vous aidera à
                  choisir la meilleure solution.
                </p>
              </>
            )}
          </div>
          <div style={footerStyle}>
            {footerRenderer ? (
              footerRenderer()
            ) : (
              <button type="button" style={primaryButtonStyle} onClick={onClose}>
                J’ai compris
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

GuaranteeHelpModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  titleRenderer: PropTypes.func,
  bodyRenderer: PropTypes.func,
  footerRenderer: PropTypes.func,
};

export default GuaranteeHelpModal;
